import {createEntityService} from "base/entity/service";
import {
    countries_api_adapter,
    countries_api_list_adapter,
    createCountries,
    createCountriesList,
} from "./Countries";
import {Service as DefaultService} from "app/common/service";

const entityService = createEntityService(
    "/api/app/countries",
    createCountries,
    createCountriesList,
    countries_api_adapter,
    countries_api_list_adapter
);

export const CountriesService = DefaultService(entityService);
